import { createAction, props } from '@ngrx/store'
import { ActivityFeedLikesEntity } from './activity-feed-likes.models'
import { HttpErrorResponse } from '@angular/common/http'

export const loadActivityFeedLikes = createAction('[ActivityFeedLikes Page] Load Activity Feed Likes')

export const clearActivityFeedLikes = createAction('[ActivityFeedLikes Page] Clear Activity Feed Likes')

export const loadActivityFeedLikesSuccess = createAction(
  '[ActivityFeedLikes/API] Load Activity Feed Likes Success',
  props<{ activityFeedLikes: ActivityFeedLikesEntity[] }>(),
)

export const loadActivityFeedLikesFailure = createAction(
  '[ActivityFeedLikes/API] Load ActivityFeedLikes Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const startLikeProcess = createAction(
  '[ActivityFeedPosts/API] Start like process',
  props<{
    activityFeedPostUuid: string
    likeByAuthProfile: ActivityFeedLikesEntity | null
    onSuccess?: () => void
  }>(),
)

export const toggleLike = createAction(
  '[ActivityFeedPosts/API] Toggle like',
  props<{
    activityFeedPostUuid: string
    likeByAuthProfile: ActivityFeedLikesEntity | null
    onSuccess?: () => void
  }>(),
)

export const likeActivityFeedPost = createAction(
  '[ActivityFeedPosts/API] Like activity feed post',
  props<{ activityFeedPostUuid: string }>(),
)

export const likeActivityFeedPostSuccess = createAction(
  '[ActivityFeedPosts/API] Like activity feed post Success',
  props<{ activityFeedLike: ActivityFeedLikesEntity }>(),
)

export const likeActivityFeedPostFailure = createAction(
  '[ActivityFeedPosts/API] Like activity feed post Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const unlikeActivityFeedPost = createAction(
  '[ActivityFeedPosts/API] unlike activity feed post',
  props<{ activityFeedLikeUuid: string }>(),
)

export const unlikeActivityFeedPostSuccess = createAction(
  '[ActivityFeedPosts/API] unlike activity feed post Success',
  props<{ activityFeedLikeUuid: string }>(),
)

export const unlikeActivityFeedPostFailure = createAction(
  '[ActivityFeedPosts/API] unlike activity feed post Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const enableActivityFeedLike = createAction('[ActivityFeedPosts/API] enable activity feed like')
export const disableActivityFeedLike = createAction('[ActivityFeedPosts/API] disable activity feed like')
